import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu, {
  BaseMenuItem,
  MenuDivider,
  type MenuProps,
} from '@/components/Menu';
import { AddFileIcon, AttestationIcon } from '@/icons';
import FileInput from '@/components/inputs/FileInput';
import { classes } from './utils';

export type NewDocumentMenuProps = {
  open: boolean;
  disabled?: boolean;
  anchorTo: HTMLElement | null;
  anchorOrigin?: MenuProps['anchorOrigin'];
  transformOrigin?: MenuProps['transformOrigin'];
  onAddFile: (file: File) => void;
  onStartTraceRecord: () => void;
  onClose: () => void;
};

export default function NewDocumentMenu({
  open,
  disabled,
  anchorTo,
  anchorOrigin,
  transformOrigin,
  onAddFile,
  onStartTraceRecord,
  onClose,
}: NewDocumentMenuProps) {
  return (
    <Menu
      anchorTo={anchorTo}
      open={open}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      onClose={onClose}>
      <FileInput
        disabled={disabled}
        className={classes.input}
        id="upload-document"
        onSelect={([file]) => onAddFile(file)}
      />
      <BaseMenuItem className={classes.menuItem}>
        <label className={classes.inputLabel} htmlFor="upload-document">
          <ListItemIcon>
            <AddFileIcon />
          </ListItemIcon>
          <ListItemText>Upload Document</ListItemText>
        </label>
      </BaseMenuItem>
      <MenuDivider className={classes.divider} />
      <BaseMenuItem className={classes.menuItem} onClick={onStartTraceRecord}>
        <ListItemIcon>
          <AttestationIcon size="1.5rem" />
        </ListItemIcon>
        <ListItemText>New Traceability Record</ListItemText>
      </BaseMenuItem>
    </Menu>
  );
}
